// extracted by mini-css-extract-plugin
export default {"itemCard":"ItemCard_itemCard__MMkhe","itemCard-main":"ItemCard_itemCard-main__xnYi3","value":"ItemCard_value__l4AnC"};